import { NetworkAppContainerWebComponent } from './component/NetworkAppContainerWebComponent';
import { WEB_COMPONENT_NETWORK_APP_CONTAINER } from '../../webcomponents.constants';

window.customElements.define(WEB_COMPONENT_NETWORK_APP_CONTAINER, NetworkAppContainerWebComponent);

export { NetworkAppContainerWebComponent };
